import { Player } from './player';
import { CubePlayer } from './cube';
import { WebPlayer } from './web';

export { Player };

export const All = '';
export const Cube = 'Cube';
export const Web = 'Web';

const playerComponents = new Map<number, Map<number, Player>>();

/* eslint-disable @typescript-eslint/no-extraneous-class */
class Factory {
  static mapping: Record<string, any> = {
    [Cube]: CubePlayer,
    [Web]: WebPlayer
  }

  static createPlayer (type: string, playerId: number, channel: number): Player {
    return new Factory.mapping[type]({ playerId, channel });
  }
}

export const assertPlayerComponent = (playerType: string, playerId: number, channel: number): Player => {
  if (!playerComponents.has(playerId)) {
    playerComponents.set(playerId, new Map<number, Player>());
  }

  let playerComponent: Player | undefined;

  const channelPlayers = playerComponents.get(playerId);
  if (channelPlayers !== undefined && channelPlayers.has(channel)) {
    playerComponent = channelPlayers.get(channel);
  }

  if (playerComponent === undefined) {
    playerComponent = Factory.createPlayer(playerType, playerId, channel);
    playerComponents.get(playerId)?.set(channel, playerComponent);
  }

  return playerComponent;
};
